import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-container">

        <div className="footer-col">
          <h4>Ratna Vastra</h4>
          <p>Where elegance meets tradition ✨</p>

          {/* Social Icons */}
          <div className="footer-social">
            <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://wa.me/8333873777" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebookF /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Site Map</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul>
            <li>📍 India</li>
            <li>📞 +91-83338 73777</li>
            <li>📧 info@ratnavastra.com</li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        © {year} Ratna Vastra. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
